import styled from "styled-components";
import { Link } from "react-router-dom";
import { MenuOutlined } from "@ant-design/icons";


export const HeaderSection = styled("header")`
  padding: 0;
  position: fixed;
  top: 0;
  left: 0;
  right: 0;
  z-index: 1000;
  background: linear-gradient(135deg, rgba(255, 255, 255, 0.98) 0%, rgba(248, 250, 252, 0.98) 100%);
  backdrop-filter: blur(20px);
  box-shadow: 0 4px 30px rgba(38, 122, 141, 0.1);
  transition: all 0.3s ease;
  border-bottom: 1px solid rgba(38, 122, 141, 0.08);

  .ant-row-space-between {
    align-items: center;
    text-align: center;
    min-height: 70px;
  }

  @media (max-width: 768px) {
    .ant-row-space-between {
      min-height: 65px;
    }
  }

  @media (max-width: 480px) {
    .ant-row-space-between {
      min-height: 60px;
    }
  }
`;

export const ScrollProgress = styled("div")`
  position: absolute;
  bottom: 0;
  left: 0;
  height: 3px;
  background: linear-gradient(90deg, #267A8D, #FEC409);
  transition: width 0.1s ease-out;
  z-index: 1001;
`;

export const LogoContainer = styled(Link)`
  display: flex;
  align-items: center;
  transition: transform 0.3s ease;

  &:hover {
    transform: scale(1.02);
  }

  img {
    filter: drop-shadow(0 2px 8px rgba(38, 122, 141, 0.15));
    transition: filter 0.3s ease;
  }

  &:hover img {
    filter: drop-shadow(0 4px 12px rgba(38, 122, 141, 0.25));
  }
`;

export const NavLink = styled("div")`
  display: inline-block;
  text-align: center;
`;

export const CustomNavLink = styled("div")`
  width: 203px;
  display: inline-block;

  @media only screen and (max-width: 411px) {
    width: 150px;
  }

  @media only screen and (max-width: 320px) {
    width: 118px;
  }
`;

export const Burger = styled("div")`
  @media only screen and (max-width: 890px) {
    display: block;
  }

  display: none;
  cursor: pointer;
  padding: 10px;
  border-radius: 12px;
  transition: all 0.3s ease;
  background: linear-gradient(135deg, rgba(38, 122, 141, 0.08) 0%, rgba(254, 196, 9, 0.08) 100%);
  border: 1px solid rgba(38, 122, 141, 0.15);

  &:hover {
    background: linear-gradient(135deg, rgba(38, 122, 141, 0.15) 0%, rgba(254, 196, 9, 0.15) 100%);
    transform: scale(1.05);
  }

  svg {
    fill: #267A8D;
    font-size: 22px;
  }
`;

export const NotHidden = styled("div")`
  display: flex;
  align-items: center;
  gap: 0.25rem;

  @media only screen and (max-width: 890px) {
    display: none;
  }
`;

export const Menu = styled("h5")`
  font-size: 1.5rem;
  font-weight: 700;
  text-align: center;
  color: #267A8D;
  margin: 0;
  background: linear-gradient(135deg, #267A8D 0%, #1a5a6e 100%);
  -webkit-background-clip: text;
  -webkit-text-fill-color: transparent;
  background-clip: text;
`;

export const CustomNavLinkSmall = styled(NavLink)<{ $isActive?: boolean }>`
  font-size: 1rem;
  color: ${({ $isActive }) => $isActive ? '#267A8D' : '#444'};
  transition: all 0.3s ease;
  margin: 0.5rem 0.75rem;
  padding: 0.5rem 1rem;
  position: relative;
  border-radius: 8px;
  font-weight: ${({ $isActive }) => $isActive ? '600' : '500'};
  cursor: pointer;

  &::before {
    content: '';
    position: absolute;
    inset: 0;
    border-radius: 8px;
    background: linear-gradient(135deg, rgba(38, 122, 141, 0.08) 0%, rgba(254, 196, 9, 0.08) 100%);
    opacity: ${({ $isActive }) => $isActive ? '1' : '0'};
    transition: opacity 0.3s ease;
  }

  &:hover::before {
    opacity: 1;
  }

  &::after {
    content: '';
    position: absolute;
    bottom: 2px;
    left: 50%;
    width: ${({ $isActive }) => $isActive ? '60%' : '0'};
    height: 2px;
    background: linear-gradient(90deg, #267A8D, #FEC409);
    transition: all 0.3s ease;
    transform: translateX(-50%);
    border-radius: 2px;
  }

  &:hover::after {
    width: 60%;
  }

  @media only screen and (max-width: 768px) {
    margin: 1.25rem 2rem;
    font-size: 1.1rem;
    padding: 0.75rem 1.25rem;
  }
`;

export const Label = styled("span")`
  font-weight: 500;
  color: #555;
  text-align: right;
  display: flex;
  justify-content: space-between;
  align-items: baseline;
`;

export const Outline = styled(MenuOutlined)`
  font-size: 22px;
  color: #267A8D;
`;

export const Span = styled("span")`
  cursor: pointer;
  transition: all 0.3s ease;
  font-weight: 500;
  letter-spacing: 0.02em;
  position: relative;
  z-index: 1;

  &:hover,
  &:active,
  &:focus {
    color: #267A8D;
  }
`;

export const ContactButton = styled("button")`
  background: linear-gradient(135deg, #267A8D 0%, #1a5a6e 100%);
  color: white;
  border: none;
  padding: 0.75rem 1.5rem;
  border-radius: 50px;
  font-weight: 600;
  font-size: 0.95rem;
  cursor: pointer;
  transition: all 0.3s ease;
  box-shadow: 0 4px 15px rgba(38, 122, 141, 0.3);
  position: relative;
  overflow: hidden;

  &::before {
    content: '';
    position: absolute;
    top: 0;
    left: -100%;
    width: 100%;
    height: 100%;
    background: linear-gradient(90deg, transparent, rgba(255, 255, 255, 0.3), transparent);
    transition: left 0.5s ease;
  }

  &:hover {
    transform: translateY(-2px);
    box-shadow: 0 6px 20px rgba(38, 122, 141, 0.4);

    &::before {
      left: 100%;
    }
  }

  @media only screen and (max-width: 890px) {
    display: none;
  }
`;
